<mat-progress-spinner class="spinner cyan" mode="indeterminate" [color]="'#327b8d'"
    [diameter]="60"></mat-progress-spinner>